import React, { Component } from 'react';
import { connect } from "react-redux";
import {setSendMuted} from 'actions/index.js';

class SendMuteButton extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    onSendMuteClicked() {
        this.props.send.mute(!this.props.send.muted);
        this.props.setSendMuted(this.props.send.sendNumber, this.props.send.muted);
        this.setState(this.state);
    }

    render() {
        return (
            <div className="group-top-buttons">
              <div
                onClick={() => this.onSendMuteClicked()}
                className={this.props.muted ? "muted group-mute-button" : "group-mute-button"}>
              </div>
            </div>
        );
   }
}

const mapStateToProps = (state, props) => {
    return {
        muted: state.tracks.sendMutes[props.send.sendNumber]
    };
};


const mapDispatchToProps = dispatch => {
    return {
        setSendMuted: (sendNumber, muted) => dispatch(setSendMuted(sendNumber, muted))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SendMuteButton);
